import { Component } from '@angular/core';

@Component({
  standalone: false,
  templateUrl: './empty-state.component.html',
  styleUrls: ['./empty-state.component.scss'],
  selector: 'empty-state'
})
export class EmptyStateComponent { }
